/* eslint-disable max-lines */
import React, { useContext, useEffect, useState } from 'react';
import { FormControlLabel, makeStyles, Radio } from '@material-ui/core';
import Grid from '@mui/material/Grid';
import {
    AutosizeTextarea,
    ClinicInput,
    CalendarInput,
    SearchableSelect,
    CancelButton,
    AlertDialog
} from '../UI';
import { Formik, Form, Field, useFormikContext } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getGenericList } from '../../redux/General/GeneralAction';
import { SubmitButton, FlatSelect } from '../UI';
import { NID, CID, phone } from '../../utils/validationRegex';
import MessagesContext from '../../contexts/messagesContext';
import { getNamespace, getClinicId } from '../../utils/storage';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useHistory, useParams } from 'react-router';
import { deletePatient, deleteSelectedPatient } from '../../redux/Patient/PatientAction';
import arrowMobile from '../../assets/images/Icon/arrowMobile.svg';
import { useIndexedDB } from 'react-indexed-db';
import { useRef } from 'react';
import { getFullDate } from '../../utils/dateTimeUtil';
import useCheckAccess from '../../hooks/useCheckAccess';
import PatientResult from './SearchResult';
import { TrashIcon } from '../UI/Images/Icons';

const styles = makeStyles((theme) => ({
    container: {
        overflow: 'hidden',
        [theme.breakpoints.up(1025)]: {
            padding: ({ isAdd }) => isAdd && '10px 20px'
        }
    },
    input: {
        '& > div': {
            width: '100% !important',
            padding: '0 !important'
        },
        '& > div input': {
            width: '100% !important'
        },
        '& > div > div:last-child': {
            padding: '0 !important'
        }
    },
    birthdayInput: {
        padding: '0 !important',
        '& > div': {
            width: '100% !important',
            padding: '0 !important'
        }
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '24px',
        '& > div:first-child': {
            width: '49%'
        },
        '& > div > div': {
            width: '100%'
        }
    },
    tabBar: {
        '& > div ': {
            width: '100%',
            padding: '0'
        },

        '& > div > div > button ': {
            width: '100%'
        }
    },
    tabBarEdit: {
        '& > div ': {
            width: '80%',
            padding: '0',
            [theme.breakpoints.down(768)]: {
                width: '100%'
            }
        }
    },
    genderTabBar: {
        '& > div ': {
            width: '100%'
            // padding: '0'
        }
    },
    submitBtnContainer: {
        marginTop: '24px',
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px',
        padding: '0 23px',
        position: 'sticky',
        bottom: '20px',
        left: '0',
        right: '0',
        flex: 1,
        marginInlineStart: 'auto',
        width: '350px',
        [theme.breakpoints.down(768)]: {
            width: 'unset',
            background: '#fff',
            justifyContent: 'space-between',
            padding: '24px 0',
            marginBottom: '-24px',
            bottom: '-24px',
            '& > div': {
                width: '48%'
            },
            '& > div > button': {
                width: '100%',
                margin: 0
            }
        }
    },
    nIDContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%'
        // paddingRight: props.rtl ? '0' : '13px',
        // paddingLeft: props.rtl ? '13px' : '0',

        // [theme.breakpoints.down(1025)]: {
        //     maxWidth: '50%',
        //     paddingRight: 0,
        //     paddingLeft: 0
        // }
    },
    radioRoot: {
        padding: '0 7px'
    },
    radioButtonContainer: {
        flexDirection: 'row',
        margin: 0,
        '& label': {
            margin: 0,
            fontSize: '0.8rem'
        }
    },
    formControlLabel: {
        flexFlow: 'row-reverse',
        margin: '0',
        position: 'absolute',
        top: '0',
        left: '0',
        '& > span': {
            padding: '0 0 0 '
        }
    },
    searchBtnContainer: {
        display: 'flex',
        alignItems: 'end',
        marginTop: ({ isAdd, rtl }) => isAdd && !rtl && '32px',
        '& button': {
            width: '100%',
            margin: '0',
            [theme.breakpoints.down(1025)]: {
                background: '#fff',
                color: '#509ffa',
                boxShadow: 'none'
            },
            [theme.breakpoints.down(768)]: {
                marginBottom: '24px'
            }
        }
    },
    searchBtn: {
        fontSize: '.8em'
    },
    form: {
        position: 'relative',
        paddingBottom: 10,
        // minWidth: (props) => props.isAdd && '800px',
        // '& *': {
        //     direction: (props) => (props.rtl ? 'rtl' : 'ltr ')
        // },
        [theme.breakpoints.down(1025)]: {
            minWidth: (props) => props.isAdd && 'unset',
            paddingBottom: 0
        }
    },
    labelRoot: {
        color: '#767676',
        paddingBottom: '6px',
        '& label': {
            opacity: '1 !important'
        }
    },
    deletePatientFile: {
        position: 'absolute',
        bottom: '40px',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: 500,
        color: '#ee384e',
        cursor: 'pointer',
        [theme.breakpoints.down(1025)]: {
            position: 'unset',
            marginTop: '20px'
        },
        '& svg': {
            margin: '0 5px'
        }
    },
    buttonIcon: ({ rtl }) => ({
        width: '15px',
        height: '15px',
        margin: '0 3px',
        transform: !rtl ? 'rotateY(180deg)' : 'unset',
        [theme.breakpoints.down(1025)]: {
            margin: '0 10px'
        }
    }),
    searchInput: {
        marginTop: '20px'
    },
    phoneNumberContainer: ({ isAdd, rtl }) => ({
        marginTop: !isAdd && !rtl && '10px !important'
    }),
    fatherContainer: ({ isAdd, rtl }) => ({
        [theme.breakpoints.down(507)]: {
            marginTop: !isAdd && !rtl && '30px !important'
        }
    }),
    creationDate: {
        marginTop: '10px',
        marginBottom: '24px',
        '& span': {
            fontSize: '13px',
            color: '#232733'
        }
    },
    editInfo: {
        color: '#232733',
        fontSize: '13px'
    },
    attendingClinics: {
        marginBottom: '30px'
    },
    clinicTitle: {
        fontSize: '13px',
        fontWeight: 500,
        color: '#545e66'
    },
    clinicsWrapper: {
        display: 'flex',
        flexFlow: 'wrap',
        [theme.breakpoints.up(1025)]: {
            width: '48%'
        }
    },
    clinic: {
        borderRadius: '4px',
        backgroundColor: '#f2f4f7',
        fontSize: '12px',
        fontWeight: 500,
        padding: '4px 8px',
        marginInlineEnd: '8px',
        marginTop: '8px'
    }
    // wrapper: {
    //     width: '60%',
    //     [theme.breakpoints.down(1025)]: {
    //         width: '100%'
    //     }
    // }
}));
const PatientForm = ({
    submitPatient,
    formType,
    loadingPatients,
    patient,
    searchPatients,
    lang
}) => {
    const { messages } = useContext(MessagesContext);
    const isMobile = useCheckMobileScreen();
    const classes = styles({ rtl: lang === 'fa', isAdd: formType === 'add', isMobile });
    const [searchEnable, setSearchEnable] = useState(false);
    const dispatch = useDispatch();
    const genderOptions = useSelector((state) => state.general?.generics?.genders);
    const history = useHistory();
    const { clinicId } = useParams();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { deleteRecord } = useIndexedDB('patients');
    const [dialog, setDialog] = useState(false);
    const nationalId = useRef();
    const datePickerFocus = useRef(false);
    const { notEditDemographic } = useCheckAccess();

    const maritalStatusOptions = useSelector((state) => state.general?.generics?.maritalStatus);
    const nationalityOptions = useSelector((state) => state.general?.generics?.nationalities);
    const cities = useSelector((state) => state.general?.generics?.cities);
    useEffect(() => {
        if (!nationalityOptions || !nationalityOptions.length) {
            dispatch(getGenericList('nationality'));
        }
        if (!cities || !cities.length) {
            dispatch(getGenericList('city'));
        }
    }, []);

    const validationObject = Yup.object({
        firstName: Yup.string()
            .min(2, messages.validations.incorrectName)
            .max(15, messages.validations.exceedMaxLength)
            // .matches(letters, messages.validations.incorrectName)
            .required(messages.validations.required),
        lastName: Yup.string()
            .min(3, messages.validations.incorrectLastName)
            .max(30, messages.validations.exceedMaxLength)
            // .matches(letters, messages.validations.incorrectLastName)
            .required(messages.validations.required),
        fatherName: Yup.string()
            .min(3, messages.validations.incorrectName)
            .max(15, messages.validations.exceedMaxLength),
        // .matches(letters, messages.validations.incorrectName),
        nationalId: Yup.string().when('notNationalId', {
            is: (value) => value === 'true',
            then: Yup.string()
                .matches(CID, messages.validations.incorrectValue)
                .required(messages.validations.required),
            otherwise: Yup.string()
                .matches(NID, messages.validations.incorrectValue)
                .required(messages.validations.required)
        }),
        phoneNumber1: Yup.string().matches(phone, messages.validations.incorrectValue),
        phoneNumber2: Yup.string().matches(phone, messages.validations.incorrectValue),
        patientCity: Yup.number().when('street', {
            is: (value) => value,
            then: Yup.number().required(messages.validations.required),
            otherwise: Yup.number().notRequired().nullable()
        })
    });

    const setInitialValues = () => {
        return {
            firstName: patient?.first_name ? patient.first_name : '',
            lastName: patient?.last_name ? patient.last_name : '',
            fatherName: patient?.father_name ? patient?.father_name : '',
            gender: patient?.gender ? patient.gender : genderOptions ? genderOptions[1].value : '',
            nationalId: patient?.national_id ? patient.national_id : '',
            nationality: patient?.nationality
                ? patient.nationality
                : nationalityOptions?.length && nationalityOptions[107]?.id,
            maritalStatus: patient?.marital_status
                ? patient.marital_status
                : maritalStatusOptions
                ? maritalStatusOptions[0].value
                : '',
            dob: patient?.dob ? patient.dob : '',
            birthLocation: patient?.birth_location ? patient.birth_location : null,
            notNationalId: patient?.has_national_id
                ? 'false'
                : patient?.has_national_id === false
                ? 'true'
                : 'false',
            phoneNumber1: patient?.phone_number_1 ? patient?.phone_number_1.trim() : '',
            phoneNumber2: patient?.phone_number_2 ? patient?.phone_number_2.trim() : '',
            patientCity: patient?.city ? patient?.city : '',
            street: patient?.street ? patient?.street.trim() : ''
        };
    };
    function createParam(values) {
        const patient = {
            namespace: getNamespace(),
            clinic: getClinicId(),
            first_name: values.firstName ? values.firstName.trim() : null,
            last_name: values.lastName ? values.lastName.trim() : null,
            father_name: values.fatherName ? values.fatherName.trim() : null,
            gender: values.gender ? values.gender : null,
            national_id: values.nationalId ? values.nationalId : null,
            nationality: values.nationality ? values.nationality : null,
            marital_status: values.maritalStatus ? values.maritalStatus : null,
            dob: values.dob ? values.dob : null,
            birth_location: values.birthLocation ? values.birthLocation : null,
            has_national_id: values.nationalId
                ? values.notNationalId === 'true'
                    ? false
                    : true
                : null,
            incognito: values.firstName && values.lastName ? false : true,
            phone_number_1: values.phoneNumber1 ? values.phoneNumber1.trim() : null,
            phone_number_2: values.phoneNumber2 ? values.phoneNumber2.trim() : null,
            city: values.patientCity ? values.patientCity : null,
            street: values.street ? values.street.trim() : null
        };
        return patient;
    }
    function handlePatientSearch(values) {
        if (formType === 'add') {
            if (values?.firstName || values?.lastName || nationalId.current) {
                setSearchEnable(true);

                searchPatients(nationalId.current, values?.firstName + ' ' + values?.lastName).then(
                    () => (datePickerFocus.current = false)
                );
            } else {
                setSearchEnable(false);
            }
        }
    }
    const renderNationalIdInput = (values, setFieldValue) => {
        const nidOptions = [
            { label: messages.NID, value: 'false' },
            { label: messages.exNID, value: 'true' }
        ];
        const handleChangeNationalId = (e) => {
            const value = e.target.value;
            nationalId.current = value?.replace(/\s+/g, '');
            setFieldValue('nationalId', value);

            let timer;
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (formType === 'add') {
                    if (values.notNationalId === 'false' && nationalId.current.length >= 10) {
                        handlePatientSearch(values);
                        return;
                    } else if (values.notNationalId === 'true' && nationalId.current?.length > 2) {
                        return handlePatientSearch(values);
                    }
                }
            }, 500);
        };

        return (
            <div className={classes.nIDContainer}>
                <Field component={RadioGroup} name="notNationalId">
                    <div className={classes.radioButtonContainer}>
                        {nidOptions.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option.value}
                                control={
                                    <Radio
                                        color="primary"
                                        classes={{ root: classes.radioRoot }}
                                        disabled={notEditDemographic}
                                    />
                                }
                                label={option.label}
                                dir="ltr"
                                classes={{ root: classes.labelRoot }}
                            />
                        ))}
                    </div>
                </Field>

                <ClinicInput
                    name="nationalId"
                    type="text"
                    data-testid="nationalId"
                    disabled={notEditDemographic}
                    autoFocus={formType === 'add'}
                    // onBlur={() => handlePatientSearch(values)}
                    onChange={handleChangeNationalId}
                />
            </div>
        );
    };

    const renderFatherNameInput = () => (
        <ClinicInput
            label={messages.fatherName}
            name="fatherName"
            type="text"
            disabled={notEditDemographic}
        />
    );
    const renderBirthDayInput = (values, setFieldValue) => (
        <CalendarInput
            width="100%"
            label={messages.birthDate}
            name="dob"
            value={values.dob}
            max={new Date()}
            setValue={(value) => setFieldValue('dob', value, false)}
            usePortal={true}
            autoFocus={datePickerFocus.current}
            disabled={notEditDemographic}
        />
    );

    const renderGenderSelect = (values, setFieldValue) => (
        <FlatSelect
            isGender
            options={genderOptions}
            selected={values.gender}
            label={messages.gender}
            name="gender"
            disabled={notEditDemographic}
            handleSelect={(e) => setFieldValue('gender', e)}
        />
    );

    const renderMaritalStatus = (values, setFieldValue) => (
        <FlatSelect
            options={maritalStatusOptions}
            selected={values.maritalStatus}
            label={messages.maritalStatus}
            name="maritalStatus"
            disabled={notEditDemographic}
            handleSelect={(e) => setFieldValue('maritalStatus', e)}
        />
    );
    const handleCancel = (resetForm) => {
        resetForm();
        history.goBack();
    };

    const handleDeletePatientFile = async () => {
        await dispatch(deletePatient(patient?.id));
        deleteRecord(+patient?.id);
        dispatch(deleteSelectedPatient(+patient?.id));
        history.replace(`/${clinicId}/patients`);
    };
    const CloseSearchBoxResult = () => {
        const { values } = useFormikContext();
        useEffect(() => {
            if (!values.lastName && !values.nationalId) {
                setSearchEnable(false);
            }
        }, [values]);
        return null;
    };
    // const search = async (values) => {
    //     setSearchEnable(true);
    //     const polyclinicId = getNamespace();
    //     if (values?.lastName) {
    //         await dispatch(getPatients(0, 20, values.lastName, values.nationalId, polyclinicId));
    //     } else {
    //         await dispatch(getPatients(0, 20, values.lastName, values, polyclinicId));
    //     }
    // };

    const handleShowAlert = (isValid) => {
        if (!isValid) {
            setDialog(true);
        }
    };

    return (
        <>
            <AlertDialog
                open={dialog}
                alertText={messages.alerts.validationPatientForm}
                cancelText={messages.alerts.ok}
                handleClose={() => setDialog(false)}
                primaryCancelButton
            />
            <AlertDialog
                open={deleteDialog}
                alertText={messages.alerts.deletePatient}
                confirmText={messages.yes}
                cancelText={messages.no}
                handleAction={handleDeletePatientFile}
                handleClose={() => setDeleteDialog(false)}
            />
            <Formik
                enableReinitialize
                validateOnChange={false}
                initialValues={setInitialValues()}
                validationSchema={validationObject}
                onSubmit={async (values, { setSubmitting }) => {
                    const patient = createParam(values);
                    await submitPatient(patient);
                    setSubmitting(false);
                }}
            >
                {({
                    values,
                    setFieldValue,
                    isSubmitting,
                    errors,
                    resetForm,
                    isValid,
                    setFieldTouched
                }) => (
                    <Form className={classes.form}>
                        {/* <div className={classes.wrapper}> */}
                        {formType === 'edit' && patient?.created && (
                            <div className={classes.creationDate}>
                                <span>{messages.creationDate} : </span>
                                <span>{getFullDate(patient.created)}</span>
                            </div>
                        )}
                        <div className={classes.container}>
                            <Grid
                                container
                                spacing={formType === 'edit' ? { xs: 2, md: 4 } : 2}
                                alignItems={
                                    formType === 'add' && lang !== 'fa' ? 'flex-end' : 'center'
                                }
                            >
                                {formType === 'add' && (
                                    <>
                                        <Grid item xs={6} md={3}>
                                            <div className={classes.input}>
                                                {renderNationalIdInput(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={6} md={3}>
                                    <div className={classes.input}>
                                        <ClinicInput
                                            label={messages.firstName}
                                            name="firstName"
                                            type="text"
                                            autoFocus={formType === 'edit'}
                                            disabled={notEditDemographic}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <div className={classes.input}>
                                        <ClinicInput
                                            label={messages.lastName}
                                            name="lastName"
                                            type="text"
                                            disabled={notEditDemographic}
                                            onBlur={() => {
                                                handlePatientSearch(values);
                                                if (errors.lastName) {
                                                    setFieldTouched('lastName', true);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab') {
                                                    datePickerFocus.current = true;
                                                }
                                            }}
                                        />
                                    </div>
                                </Grid>
                                {formType === 'add' && (
                                    <Grid item xs={12} md={3} alignSelf={'center'}>
                                        <div className={classes.searchBtnContainer}>
                                            <SubmitButton
                                                submitText={messages.search}
                                                isSubmitting={loadingPatients}
                                                disableSubmit={true}
                                                handleClick={() => {
                                                    handlePatientSearch(values);
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                )}
                            </Grid>

                            {formType === 'add' && (
                                <>
                                    <div>
                                        {searchEnable && (
                                            <PatientResult loading={loadingPatients} />
                                        )}
                                    </div>
                                    {/* <hr className="form-divider" /> */}
                                </>
                            )}
                            {formType === 'edit' && (
                                <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
                                    <Grid item xs={6} md={3}>
                                        <div className={classes.input}>
                                            {renderNationalIdInput('', setFieldValue)}
                                        </div>
                                    </Grid>
                                    <Grid item xs={6} md={3} className={classes.fatherContainer}>
                                        <div className={classes.input}>
                                            {renderFatherNameInput()}
                                        </div>
                                    </Grid>
                                </Grid>
                            )}

                            {formType === 'edit' ? (
                                <>
                                    <Grid
                                        container
                                        spacing={{ xs: 2, md: 4 }}
                                        alignItems="baseline"
                                    >
                                        <Grid item xs={6} md={3}>
                                            <div className={classes.birthdayInput}>
                                                {renderBirthDayInput(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <div className={classes.genderTabBar}>
                                                {renderGenderSelect(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
                                        <Grid item xs={12} md={7}>
                                            <div className={classes.tabBarEdit}>
                                                {renderMaritalStatus(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid container spacing={2} alignItems="baseline">
                                        <Grid item xs={6} md={3}>
                                            <div className={classes.birthdayInput}>
                                                {renderBirthDayInput(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <div className={classes.input}>
                                                {renderFatherNameInput()}
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} alignItems={'center'}>
                                        <Grid item xs={12} md={8}>
                                            <div className={classes.tabBar}>
                                                {renderMaritalStatus(values, setFieldValue)}
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <div className={classes.tabBar}>
                                                {renderGenderSelect(values, setFieldValue)}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {lang === 'fa' && (
                                <Grid
                                    container
                                    spacing={formType === 'edit' ? { xs: 2, md: 4 } : 2}
                                    alignItems="center"
                                >
                                    <Grid item xs={6} md={3}>
                                        <div className={classes.searchInput}>
                                            <SearchableSelect
                                                width="100%"
                                                options={nationalityOptions}
                                                optionsLabel="title"
                                                label={messages.nationality}
                                                name="nationality"
                                                value={values.nationality}
                                                disabledSituation={notEditDemographic}
                                                setValue={(value) => {
                                                    if (value !== nationalityOptions[103]?.id) {
                                                        setFieldValue('birthLocation', null, false);
                                                    }
                                                    setFieldValue('nationality', value, false);
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <div className={classes.searchInput}>
                                            <SearchableSelect
                                                width="100%"
                                                disabledSituation={
                                                    values.nationality !== 'IR' ||
                                                    notEditDemographic
                                                }
                                                options={cities}
                                                optionsLabel="title"
                                                label={messages.birthplace}
                                                name="birthLocation"
                                                value={values.birthLocation}
                                                setValue={(value) =>
                                                    setFieldValue('birthLocation', value, false)
                                                }
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid
                                container
                                spacing={formType === 'edit' ? { xs: 2, md: 4 } : 2}
                                alignItems="center"
                                className={classes.phoneNumberContainer}
                                // Why did I add the class?
                                // cause the upper field does not have a validation element,
                                // its place is empty and this field sticks to the upper field.
                                //The method should be changed later
                            >
                                <Grid item xs={6} md={3}>
                                    <div className={classes.input}>
                                        <ClinicInput
                                            name="phoneNumber1"
                                            label={messages.phoneNo}
                                            type="text"
                                            disabled={notEditDemographic}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <div className={classes.input}>
                                        <ClinicInput
                                            name="phoneNumber2"
                                            label={messages.phoneNo2}
                                            type="text"
                                            disabled={notEditDemographic}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            {lang === 'fa' && (
                                <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
                                    <Grid item xs={6} md={6}>
                                        <div className={classes.input}>
                                            <SearchableSelect
                                                width="100%"
                                                options={cities}
                                                optionsLabel="title"
                                                label={messages.city}
                                                name="patientCity"
                                                value={values.patientCity}
                                                errors={errors.patientCity}
                                                disabledSituation={notEditDemographic}
                                                setValue={(value) =>
                                                    setFieldValue('patientCity', value, false)
                                                }
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <div className={classes.input}>
                                        <AutosizeTextarea
                                            name="street"
                                            label={messages.address}
                                            disabled={notEditDemographic}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        {/* </div> */}

                        {formType === 'edit' ? (
                            <div>
                                {patient?.attending_clinics?.length ? (
                                    <div className={classes.attendingClinics}>
                                        <span className={classes.clinicTitle}>
                                            {messages.attendingClinics}
                                        </span>
                                        <div className={classes.clinicsWrapper}>
                                            {patient?.attending_clinics?.map((item) => (
                                                <span className={classes.clinic} key={item.id}>
                                                    {item.name}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                ) : null}

                                {patient?.last_editor?.id && (
                                    <div className={classes.editInfo}>
                                        <span>{messages.editedBy} </span>
                                        <span>
                                            {patient.last_editor?.first_name}{' '}
                                            {patient.last_editor?.last_name}
                                        </span>
                                        <span> {messages.inDate} </span>
                                        <span>{getFullDate(patient.modified)}</span>
                                    </div>
                                )}
                                <div
                                    className={classes.deletePatientFile}
                                    onClick={() => setDeleteDialog(true)}
                                    data-testid="trashIcon"
                                >
                                    <TrashIcon width="20" height="20" />
                                    {messages.deletePatientFile}
                                </div>
                            </div>
                        ) : null}
                        <div className={classes.submitBtnContainer}>
                            <div>
                                <SubmitButton
                                    isSubmitting={isSubmitting}
                                    submitText={
                                        patient ? messages.saveChanges : messages.submitPatient
                                    }
                                    disabled={notEditDemographic}
                                    isButton
                                    handleClick={() => handleShowAlert(isValid)}
                                />
                            </div>
                            <div>
                                <CancelButton
                                    customColor="#989ea3"
                                    disable={isSubmitting}
                                    onClick={() => handleCancel(resetForm)}
                                >
                                    {messages.back}{' '}
                                    <img
                                        src={arrowMobile}
                                        alt="arrow"
                                        className={classes.buttonIcon}
                                    />
                                </CancelButton>
                            </div>
                        </div>
                        <CloseSearchBoxResult />
                    </Form>
                )}
            </Formik>
        </>
    );
};

PatientForm.propTypes = {
    patient: PropTypes.object,
    submitPatient: PropTypes.func,
    formType: PropTypes.string,
    loadingPatients: PropTypes.bool,
    searchPatients: PropTypes.func,
    handleCancel: PropTypes.func,
    lang: PropTypes.string
};

export default PatientForm;
